"use client";

interface QuarterZipPreviewProps {
  races: {
    long: number;
    middle: number;
    olympic: number;
    sprint: number;
  };
}

export function QuarterZipPreview({ races }: QuarterZipPreviewProps) {
  // Create race indicators (I bars and five-bar gates)
  const renderRaceIndicators = (count: number) => {
    if (count === 0) return null;

    const indicators = [];
    // Calculate complete sets of 5
    const fiveBars = Math.floor(count / 5);
    // Calculate remainder
    const remainder = count % 5;

    // Add five-bar gates
    for (let i = 0; i < fiveBars; i++) {
      indicators.push(
        <img
          key={`five-bar-${i}`}
          src="/icons/badges/race-five-bar.svg"
          alt="Five race indicator"
          // -2.7px lol, hack to get the alignment right
          style={{ height: indivAchievementSize, marginLeft: "-2.7px" }}
          className="w-auto"
        />
      );
    }

    // Add remaining individual bars
    for (let i = 0; i < remainder; i++) {
      indicators.push(
        <img
          key={`indicator-${i}`}
          src="/icons/badges/race-i.svg"
          alt="Race indicator"
          style={{ height: indivAchievementSize }}
          className="w-auto"
        />
      );
    }
    return indicators;
  };

  const indivAchievementSize = "12px";

  // Calculate how many types of races are being displayed
  const activeRaceTypes = [
    races.long > 0,
    races.middle > 0,
    races.olympic > 0,
    races.sprint > 0,
  ].filter(Boolean).length;

  // Only apply top margin if we have 2 or fewer race types
  const containerMarginTop = activeRaceTypes <= 2 ? "mt-3" : "";

  return (
    <div className="flex flex-col items-center space-y-6">
      <div className="relative mx-auto h-[400px] w-[300px] md:h-[500px] md:w-[400px] flex items-center justify-center">
        {/* Quarter zip base image */}
        <div className="relative w-full h-full flex items-center justify-center">
          <img
            src="/icons/badges/customization-base.png"
            alt="Quarter Zip Base"
            className="max-w-full max-h-full object-contain"
          />

          {/* Badge container with red outline for positioning */}
          <div
            className="absolute border-red-500"
            style={{
              top: "25%",
              left: "25%",
              width: "20%",
              height: "15%",
            }}
          >
            {/* Badge grid layout */}
            <div
              className={`w-fit mx-auto grid grid-cols-[auto_auto] gap-y-1.5 content-center justify-center place-content-center ${containerMarginTop}`}
            >
              {/* Long distance row */}
              {races.long > 0 && (
                <>
                  <div className="flex justify-end">
                    <img
                      src="/icons/badges/long-distance-icon.svg"
                      alt="Long distance badge"
                      style={{ width: indivAchievementSize }}
                      className="h-auto"
                    />
                  </div>
                  <div className="flex items-center gap-0.5 pl-1">
                    {renderRaceIndicators(races.long)}
                  </div>
                </>
              )}

              {/* Middle distance row */}
              {races.middle > 0 && (
                <>
                  <div className="flex justify-end">
                    <img
                      src="/icons/badges/middle-distance-icon.svg"
                      alt="Middle distance badge"
                      style={{ width: indivAchievementSize }}
                      className="h-auto"
                    />
                  </div>
                  <div className="flex items-center gap-0.5 pl-1">
                    {renderRaceIndicators(races.middle)}
                  </div>
                </>
              )}

              {/* Olympic distance row */}
              {races.olympic > 0 && (
                <>
                  <div className="flex justify-end">
                    <img
                      src="/icons/badges/olympic-distance-icon.svg"
                      alt="Olympic distance badge"
                      style={{ width: indivAchievementSize }}
                      className="h-auto"
                    />
                  </div>
                  <div className="flex items-center gap-0.5 pl-1">
                    {renderRaceIndicators(races.olympic)}
                  </div>
                </>
              )}

              {/* Sprint distance row */}
              {races.sprint > 0 && (
                <>
                  <div className="flex justify-end">
                    <img
                      src="/icons/badges/sprint-distance-icon.svg"
                      alt="Sprint distance badge"
                      style={{ width: indivAchievementSize }}
                      className="h-auto"
                    />
                  </div>
                  <div className="flex items-center gap-0.5 pl-1">
                    {renderRaceIndicators(races.sprint)}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
